/**
 * @internal
 */
export const PRIMITIVES = Symbol.for('ember-primitives-globals');
